import React, { useEffect, useMemo, useState } from 'react'
import { Badge, Card, Container } from 'react-bootstrap'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { Bell } from 'react-bootstrap-icons'
import { LuGraduationCap } from 'react-icons/lu'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import { useNavigate } from 'react-router-dom'

export default function CreateNotification() {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1
        setMarginLeft(
          isCollapsed ? `${collapsedWidth + gap}px` : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }
      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const hardcodedRows = useMemo(
    () => [
      {
        id: 'NTF-1001',
        title: 'Fee Reminder',
        audience: 'Student',
        course: 'BCA',
        className: 'Sem 2',
        scheduleAt: '2026-03-20 10:00',
        status: 'Scheduled',
      },
      {
        id: 'NTF-1002',
        title: 'PTM Tomorrow',
        audience: 'Teacher',
        course: '-',
        className: '-',
        scheduleAt: '2026-03-19 09:00',
        status: 'Sent',
      },
      {
        id: 'NTF-1003',
        title: 'Holiday Notice',
        audience: 'All',
        course: '-',
        className: '-',
        scheduleAt: '-',
        status: 'Draft',
      },
    ],
    [],
  )

  return (
    <>
      <style>
        {`
          .page-title {
            font-family: 'Inter', system-ui, sans-serif;
            letter-spacing: -0.02em;
            color: #223843;
          }
          .modern-card {
            background: #ffffff;
            border: 1px solid #D1D3D4;
            border-radius: 12px;
            overflow: hidden;
          }
          /* Match AddStudent.js premium table behavior */
          .table td {
            overflow: visible !important;
            user-select: text;
          }
          .table tbody tr {
            overflow: visible !important;
            cursor: default;
          }
          .table-card {
            overflow: visible !important;
          }
          .table-wrapper {
            overflow-x: auto;
            overflow-y: visible !important;
            position: relative;
          }
          .table td, .table th { user-select: text; }
        `}
      </style>

      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: '12px',
          paddingRight: '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
                gap: '12px',
              }}
            >
              <div className="d-flex align-items-center gap-3" style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>
                <div style={{ minWidth: 0 }}>
                  <h3
                    className="m-0 fw-bold page-title text-start"
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: isMobile ? '14px' : 'clamp(18px, 2.5vw, 22px)',
                      lineHeight: '1.2',
                    }}
                  >
                    Manage Notifications
                  </h3>
                  <p className="m-0 mt-0 text-start" style={{ fontSize: isMobile ? '10px' : '13px', color: '#6b7280' }}>
                    View and manage notifications.
                  </p>
                </div>
                
              </div>

              {!isMobile && (
                <div className="d-flex align-items-center gap-3" style={{ justifyContent: 'flex-end' }}>
                  <ProfileDropdown logout={logout} notificationCount={3} showNotifications={true} />
                </div>
              )}
            </div>
          </div>
        </div>

        <Container
          fluid
          className="p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
          }}
        >
          {/* Dedicated Add New button (moves out of header) */}
          <div className="d-flex justify-content-end align-items-center mb-4">
              <button
                onClick={() => navigate('/CreateNotification')}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New"
              >
                <Bell size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Notification
                </span>
              </button>
          </div>
          {/* Table (redesigned like AddStudent.js) */}
          <Card
            className="table-card"
            style={{
              border: '1px solid #D1D3D4',
              borderRadius: '12px',
              overflow: 'visible',
              backgroundColor: '#ffffff',
              position: 'relative',
            }}
          >
            <div
              className="table-wrapper"
              style={{
                overflowX: 'auto',
                overflowY: 'visible',
                position: 'relative',
                borderRadius: '12px',
              }}
            >
              <Table
                className="table mb-0"
                style={{
                  borderRadius: '12px',
                  overflow: 'visible',
                  position: 'relative',
                  marginBottom: '0',
                }}
              >
                <Thead>
                  <Tr style={{ backgroundColor: '#F3F4F6' }}>
                    <Th
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        padding: '16px',
                        border: 'none',
                        borderBottom: '1px solid #D1D3D4',
                        textAlign: 'left',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      ID
                    </Th>
                    <Th
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        padding: '16px',
                        border: 'none',
                        borderBottom: '1px solid #D1D3D4',
                        textAlign: 'left',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      Title
                    </Th>
                    <Th
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        padding: '16px',
                        border: 'none',
                        borderBottom: '1px solid #D1D3D4',
                        textAlign: 'left',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      Audience
                    </Th>
                    <Th
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        padding: '16px',
                        border: 'none',
                        borderBottom: '1px solid #D1D3D4',
                        textAlign: 'left',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      Course
                    </Th>
                    <Th
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        padding: '16px',
                        border: 'none',
                        borderBottom: '1px solid #D1D3D4',
                        textAlign: 'left',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      Class
                    </Th>
                    <Th
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        padding: '16px',
                        border: 'none',
                        borderBottom: '1px solid #D1D3D4',
                        textAlign: 'left',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      Schedule
                    </Th>
                    <Th
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        padding: '16px',
                        border: 'none',
                        borderBottom: '1px solid #D1D3D4',
                        textAlign: 'left',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      Status
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {hardcodedRows.map((r, index) => (
                    <Tr
                      key={r.id}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                        transition: 'background-color 0.2s ease',
                        borderBottom: '1px solid #E5E7EB',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor =
                          'rgba(37, 99, 235, 0.06)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor =
                          index % 2 === 0
                            ? '#ffffff'
                            : 'rgba(243, 244, 246, 0.4)'
                      }}
                    >
                      <Td
                        style={{
                          fontSize: '14px',
                          padding: '16px',
                          border: 'none',
                          color: '#111827',
                          textAlign: 'left',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {r.id}
                      </Td>
                      <Td
                        style={{
                          fontSize: '14px',
                          padding: '16px',
                          border: 'none',
                          color: '#111827',
                          textAlign: 'left',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          fontWeight: 600,
                          minWidth: '220px',
                        }}
                      >
                        {r.title}
                      </Td>
                      <Td
                        style={{
                          fontSize: '14px',
                          padding: '16px',
                          border: 'none',
                          color: '#111827',
                          textAlign: 'left',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <Badge
                          bg="light"
                          text="primary"
                          style={{ border: '1px solid #D1D3D4' }}
                        >
                          {r.audience}
                        </Badge>
                      </Td>
                      <Td
                        style={{
                          fontSize: '14px',
                          padding: '16px',
                          border: 'none',
                          color: '#111827',
                          textAlign: 'left',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {r.course}
                      </Td>
                      <Td
                        style={{
                          fontSize: '14px',
                          padding: '16px',
                          border: 'none',
                          color: '#111827',
                          textAlign: 'left',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {r.className}
                      </Td>
                      <Td
                        style={{
                          fontSize: '14px',
                          padding: '16px',
                          border: 'none',
                          color: '#111827',
                          textAlign: 'left',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {r.scheduleAt}
                      </Td>
                      <Td
                        style={{
                          fontSize: '14px',
                          padding: '16px',
                          border: 'none',
                          color: '#111827',
                          textAlign: 'left',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <Badge
                          bg={
                            r.status === 'Sent'
                              ? 'success'
                              : r.status === 'Scheduled'
                                ? 'warning'
                                : 'secondary'
                          }
                        >
                          {r.status}
                        </Badge>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </div>
          </Card>
        </Container>
      </div>
    </>
  )
}


